import { useEffect } from "react";
import { useAtom, useAtomValue } from "jotai";
import { workspaceIdAtom } from "../../atoms/WorkspaceAtoms";
import { sidebarOpenAtom } from "../../atoms/SidebarAtoms";
import { switcherOpenAtom } from "../../atoms/SidebarAtoms";
import { IsMobileAtom } from "../../App";
import useWorkspaces from "../../api/api-hooks/workspaces/useWorkspaces";
import DesktopSidebar from "./DesktopSidebar";
import MobileSidebar from "./MobileSidebar";
import useWorkspace from "../../api/api-hooks/workspaces/useWorkspace";

interface SidebarProps {
  links: { id: string; type: string; css: string; pageType: string }[];
  requiresWorkspace: boolean;
  children: React.ReactNode;
}

const Sidebar = ({ links, requiresWorkspace, children }: SidebarProps) => {
  const [open, setOpen] = useAtom(sidebarOpenAtom);
  const { workspace } = useWorkspace();
  const { workspaceIds, workspacesLoading } = useWorkspaces();
  const workspaceID = useAtomValue(workspaceIdAtom);
  const [switcherOpen, setSwitcherOpen] = useAtom(switcherOpenAtom);
  const smallScreen = useAtomValue(IsMobileAtom);

  const workspaceLoading = workspacesLoading;

  // Reset switcher open whenever sidebar is closed
  useEffect(() => {
    if (!open) {
      setSwitcherOpen(false);
    }
  }, [open, setSwitcherOpen]);

  const toggleOpen = () => {
    setOpen((prev) => !prev);
  };

  return !smallScreen || !requiresWorkspace ? (
    <DesktopSidebar
      open={open}
      smallScreen={smallScreen}
      switcherOpen={switcherOpen}
      requiresWorkspace={requiresWorkspace}
      workspaceLoading={workspaceLoading}
      workspace={workspace}
      workspaceID={workspaceID || ""}
      workspaceIds={workspaceIds}
      toggleOpen={toggleOpen}
      links={links}
    >
      {children}
    </DesktopSidebar>
  ) : (
    <MobileSidebar
      open={open}
      smallScreen={smallScreen}
      switcherOpen={switcherOpen}
      requiresWorkspace={requiresWorkspace}
      workspaceLoading={workspaceLoading}
      workspace={workspace}
      workspaceID={workspaceID || ""}
      workspaceIds={workspaceIds}
      toggleOpen={toggleOpen}
      links={links}
      setOpen={setOpen}
    >
      {children}
    </MobileSidebar>
  );
};

export { Sidebar };
